import React from "react";
import Icon from "./Icon";
import SectionHeader from "./SectionHeader";

const FEATURES = [
  {
    icon: "search",
    title: "AI Legal Research",
    text: "Ask in plain English. Get a structured research brief with every proposition linked to the judgment, notification or provision behind it.",
    points: [
      "Case law, news, notifications and regulatory insights in one view",
      "Select sources and send them straight to a draft",
    ],
  },
  {
    icon: "litigation",
    title: "Litigation Management",
    text: "Create a litigation in minutes — parties, forum, case numbers, issues, notices and orders — with research and drafts attached to the matter.",
    points: [
      "Matter timeline with orders and next dates",
      "Team assignment and status at a glance",
    ],
  },
  {
    icon: "bell",
    amber: true,
    title: "Relevance-Based Alerts",
    text: "Vedum watches cause lists, new judgments and notifications that matter to each litigation — ranked by relevance, not volume.",
    points: [
      "Upcoming listings tied to your matters",
      "New precedent on the issues you’re arguing",
    ],
  },
  {
    icon: "doc",
    title: "AI Drafting — Draft Studio",
    text: "Turn selected authorities into replies to show-cause notices, appeals, writ petitions, written submissions and opinions — structured and cited.",
    points: [
      "Formats familiar to Indian forums",
      "Your chamber’s templates and tone",
    ],
  },
  {
    icon: "chart",
    title: "Legal Insights",
    text: "See how an issue is trending, how forums have ruled and which alerts need you first — visual insight on top of every research question.",
    points: [
      "Issue trends and outcome patterns by forum",
      "Research maps grouping authorities by issue",
    ],
  },
  {
    icon: "history",
    title: "Search History",
    text: "Every query, brief and selected source is saved — so research is reusable across matters, juniors and partners.",
    points: [
      "Reopen any past research with its citations",
      "Build your chamber’s knowledge base",
    ],
  },
];

const Platform = () => (
  <section id="platform" className="vd-section vd-section--soft">
    <div className="container">
      <SectionHeader
        eyebrow="THE PLATFORM"
        title="One workspace for the full life of a matter."
      >
        From the first research question to the final order, every step lives in
        the Vedum portal — connected, cited and auditable.
      </SectionHeader>
      <div className="row g-4">
        {FEATURES.map((f) => (
          <div className="col-md-6 col-lg-4" key={f.title}>
            <div className="vd-card vd-feature">
              <span
                className={`vd-icon-box ${f.amber ? "vd-icon-box--amber" : ""}`}
              >
                <Icon
                  name={f.icon}
                  size={24}
                  color={f.amber ? "#B4690E" : "#1E3270"}
                  strokeWidth={1.8}
                />
              </span>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
              <ul>
                {f.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Platform;
